import { CheckCircleIcon } from '@heroicons/react/outline'
import { IoCopyOutline } from 'react-icons/io5'
import { useState } from 'react'
import notify from 'components/atoms/Notify'

const BookingSuccessModal = ({ close, modelYear, make, model, bookingUrl }) => {
  const [copied, setCopied] = useState(false)

  const handleCopyUrl = () => {
    if (bookingUrl) {
      navigator.clipboard.writeText(bookingUrl).then(() => {
        setCopied(true)
        notify.success('URL copied to clipboard')
        setTimeout(() => setCopied(false), 2000)
      })
    }
  }

  const getCarDescription = () => {
    const parts = []
    if (make) parts.push(make)
    if (model) parts.push(model)
    if (modelYear) parts.push(`${modelYear}`)

    if (parts.length > 0) {
      return parts.join(' ')
    }
    return 'the selected car'
  }

  return (
    <div className="p-6">
      <div className="flex flex-col items-center justify-center text-center">
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-4">
          <CheckCircleIcon className="h-10 w-10 text-green-600" aria-hidden="true" />
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">Booking Created Successfully!</h3>
        <p className="text-sm text-gray-500 mb-6">Booking for {getCarDescription()} has been successfully created.</p>

        {bookingUrl && (
          <div className="w-full mb-6">
            <label htmlFor="booking-url-input" className="block text-sm font-medium text-gray-700 mb-2 text-left">
              Booking URL:
            </label>
            <div className="flex items-center gap-2 bg-gray-50 border border-gray-300 rounded-md p-3">
              <input id="booking-url-input" type="text" value={bookingUrl} readOnly className="flex-1 text-sm text-gray-700 bg-transparent border-none outline-none" />
              <button
                type="button"
                onClick={handleCopyUrl}
                className="flex items-center gap-1 px-3 py-1.5 text-sm font-medium text-dark-600 hover:text-dark-700 hover:bg-gray-200 rounded transition-colors"
                title="Copy URL"
              >
                <IoCopyOutline className="w-4 h-4" />
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>
          </div>
        )}

        <button
          type="button"
          onClick={close}
          className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-dark-600 hover:bg-dark-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-dark-500"
        >
          Close
        </button>
      </div>
    </div>
  )
}

export default BookingSuccessModal
